// src/components/operationCenter/widgets/token/risk/TwSkewKurtosisWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import SkewKurtosisCard from "@/components/tokenPage/risk/SkewKurtosisCard";

const TwSkewKurtosisWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["price"]}>
        <SkewKurtosisCard />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwSkewKurtosisWidget;
